export default "__VITE_ASSET__DKdNHl7i__"